"use client"

import * as React from "react"
import { usePathname } from "next/navigation"
import { PublicHeader } from "../navigation/public-header"
import { Footer } from "../navigation/Footer"
import { AssistantProvider } from "../ai/AssistantContext"
import { FloatingAssistant } from "../ai/FloatingAssistant"
import ClickSpark from "../ClickSpark"
import { CookieConsent } from "../CookieConsent"

interface AppLayoutProps {
  children: React.ReactNode
}

export function AppLayout({ children }: AppLayoutProps) {
  const pathname = usePathname()

  // Routes that should NOT use the DefaultLayout (they have their own specific layouts)
  const excludeDefaultLayout = React.useMemo(() => {
    const excludedPrefixes = ["/account", "/admin", "/auth"]
    return excludedPrefixes.some(prefix => pathname?.startsWith(prefix))
  }, [pathname])

  if (excludeDefaultLayout) {
    return <>{children}</>
  }

  return (
    <AssistantProvider>
      <ClickSpark
        sparkColor='hsl(var(--primary))'
        sparkSize={10}
        sparkRadius={30}
        sparkCount={8}
        duration={400}
      >
        <div className="flex min-h-screen flex-col bg-background">
          <PublicHeader
            branding={{
              title: "Djotta",
              homeUrl: "/",
            }}
          />
          <main className="flex-1 w-full">
            {children}
          </main>
          <Footer />
          <FloatingAssistant />
          <CookieConsent />
        </div>
      </ClickSpark>
    </AssistantProvider>
  )
}
